import React from 'react';
import SEO from '../../components/SEO/SEO';
import './GestorTFCSurPage.css';

const GestorTFCSurPage = ({ darkMode, toggleDarkMode }) => {
  return (
    <>
      <SEO 
        title="Gestor TFC Sur | E-ASY"
        description="Accede al sistema de gestión y reservas de TFC Sur. Horarios y programación disponible."
        keywords="gestor, tfc sur, horarios, reservas, programación, gestión"
        canonical="https://e-asy.es/gestor-tfcsur"
      />
      <div className={`gestor-tfcsur-page ${darkMode ? 'dark' : 'light'}`}>
        <iframe 
          src="https://www.supersaas.es/schedule/TFC_Sur/Horario_TFC"
          title="Gestor TFC Sur - Sistema de Reservas"
          className="gestor-iframe"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </>
  );
};

export default GestorTFCSurPage; 